class PerformanceBars extends window.BAO.CustomElement {
  constructor () {
    super()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setupListeners()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.animateOnScroll()
  }

  animateOnScroll () {

    this.els.range.elements.forEach(rangeEl => {
      const itemElements = rangeEl.querySelectorAll(`[data-bar-element]`)
      itemElements.forEach(itemElement => {
        itemElement.classList.add(`prd-TechnicalPerformance_Range-animate`)     
      })
    })

    // this.els.range.elements.forEach(rangeEl => {
    //   const itemTriggerPoint =
    //     this.getOffsetTop(rangeEl) - (window.innerHeight / 3) * 2

    //   if (this.lastKnownY > itemTriggerPoint) {
    //     const itemElements = rangeEl.querySelectorAll(`[data-bar-element]`)
    //     let timeoutOffset = 0

    //     itemElements.forEach(itemElement => {
    //       timeoutOffset = timeoutOffset + 100

    //       setTimeout(() => {
    //         itemElement.classList.add(`prd-TechnicalPerformance_Range-animate`)
    //       }, timeoutOffset)
    //     })
    //   }
    // })
  }

  getOffsetTop (el, parent = document.body, offsetTop = 0) {
    if (!el.offsetParent) {
      return el.offsetTop
    }
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop
    }

    return el.offsetParent === parent
      ? offsetTop
      : this.getOffsetTop(el.offsetParent, parent, offsetTop)
  }
}

customElements.define('performance-bars', PerformanceBars)
